//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
// import FieldComponents from '../charts-widget/index'
import i18n, { changeLocale } from '@/utils/i18n';
export default {
  name: 'VFormWidget',
  componentName: 'VFormWidget',
  mixins: [i18n],
  components: {
    Draggable: Draggable
  },
  props: {
    designer: Object,
    formConfig: Object,
    optionData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;
    return {
      refList: this.widgetRefList,
      getFormConfig: function getFormConfig() {
        return _this.formConfig;
      },
      getGlobalDsv: function getGlobalDsv() {
        return _this.globalDsv;
      },
      globalOptionData: this.optionData,
      getOptionData: function getOptionData() {
        return _this.optionData;
      },
      getReadMode: function getReadMode() {
        return !1;
      },
      globalModel: {
        formModel: this.formModel
      },
      getSubFormFieldFlag: function getSubFormFieldFlag() {
        return !1;
      },
      getSubFormName: function getSubFormName() {
        return '';
      },
      getObjectFieldFlag: function getObjectFieldFlag() {
        return !1;
      },
      getObjectName: function getObjectName() {
        return '';
      },
      getDSResultCache: function getDSResultCache() {
        return _this.dsResultCache;
      }
    };
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      formModel: {},
      widgetRefList: {},
      dsResultCache: {}
    };
  },
  computed: {
    labelPosition: function labelPosition() {
      return !!this.designer.formConfig && !!this.designer.formConfig.labelPosition ? this.designer.formConfig.labelPosition : 'left';
    },
    size: function size() {
      return !!this.designer.formConfig && !!this.designer.formConfig.size ? this.designer.formConfig.size : 'default';
    },
    customClass: function customClass() {
      return this.designer.formConfig.customClass || '';
    },
    layoutType: function layoutType() {
      return this.designer.getLayoutType();
    }
  },
  watch: {
    'designer.widgetList': {
      deep: !0,
      handler: function handler(o) {}
    },
    'designer.formConfig': {
      deep: !0,
      handler: function handler(o) {}
    }
  },
  created: function created() {
    this.designer.loadPresetCssCode(this.getDesignerConfig().presetCssCode);
  },
  mounted: function mounted() {
    this.disableFirefoxDefaultDrop(), this.designer.registerFormWidget(this);
  },
  methods: {
    getWidgetName: function getWidgetName(o) {
      return o.type + '-widget';
    },
    disableFirefoxDefaultDrop: function disableFirefoxDefaultDrop() {
      navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && (document.body.ondrop = function (e) {
        e.stopPropagation(), e.preventDefault();
      });
    },
    onDragEnd: function onDragEnd(o) {},
    onDragAdd: function onDragAdd(o) {
      var e = o.newIndex;
      this.designer.widgetList[e] && this.designer.setSelected(this.designer.widgetList[e]), this.designer.emitHistoryChange(), this.designer.emitEvent('field-selected', null);
    },
    onDragUpdate: function onDragUpdate() {
      this.designer.emitHistoryChange();
    },
    checkMove: function checkMove(o) {
      return this.designer.checkWidgetMove(o);
    },
    getFormData: function getFormData() {
      return this.formModel;
    },
    getWidgetRef: function getWidgetRef(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = this.widgetRefList[o];
      return !n && !!e && this.$message.error(this.i18nt('designer.hint.refNotFound') + o), n;
    },
    getSelectedWidgetRef: function getSelectedWidgetRef() {
      var o = this.designer.selectedWidgetName;
      return this.getWidgetRef(o);
    },
    clearWidgetRefList: function clearWidgetRefList() {
      var _this2 = this;
      Object.keys(this.widgetRefList).forEach(function (o) {
        delete _this2.widgetRefList[o];
      });
    },
    deleteWidgetRef: function deleteWidgetRef(o, e) {
      e ? delete this.widgetRefList[o + '@sf' + e] : delete this.widgetRefList[o];
    },
    deletedChildrenRef: function deletedChildrenRef(o) {
      var _this3 = this;
      o.forEach(function (e) {
        delete _this3.widgetRefList[e];
      });
    }
  }
};